import axios from 'axios'
const URL_BASE = process.env.ROOT_API + '/email'

export class ContatoService {
  static enviarEmailContato (form) {
    return axios.post(URL_BASE + '/enviarEmailContato', form)
  }
  static enviarEmailOrcamento (form) {
    return axios.post(URL_BASE + '/enviarEmailOrcamento', form)
  }
  static ligarApi () {
    return axios.get(URL_BASE + '/ligarApi')
  }
}



// WEBPACK FOOTER //
// ./src/service/contatoService.js